/* eslint-disable no-undef */

import { isServer, type ReactiveController, type ReactiveControllerHost } from "lit";

export class EventController implements ReactiveController {
  private listeners: Array<() => void> = [];

  constructor(host: ReactiveControllerHost) {
    host.addController(this);
  }

  hostDisconnected() {
    this.listeners.forEach((stop) => stop());
    this.listeners = [];
  }

  listen<K extends string, T extends EventTarget>(
    elementOrType: T | K,
    typeOrListener: K | EventListenerOrEventListenerObject,
    listenerOrOptions?: EventListenerOrEventListenerObject | boolean | AddEventListenerOptions,
    options?: boolean | AddEventListenerOptions
  ): void {
    let element: EventTarget;
    let type: string;
    let listener: EventListenerOrEventListenerObject;
    let listenerOptions: boolean | AddEventListenerOptions | undefined;

    if (typeof elementOrType === "string") {
      element = window;
      type = elementOrType;
      listener = typeOrListener as EventListenerOrEventListenerObject;
      listenerOptions = listenerOrOptions as boolean | AddEventListenerOptions | undefined;
    } else {
      // When first arg is element
      element = elementOrType;
      type = typeOrListener as string;
      listener = listenerOrOptions as EventListenerOrEventListenerObject;
      listenerOptions = options;
    }

    if (!element || isServer) return;

    element.addEventListener(type, listener, listenerOptions);

    const stop = () => element.removeEventListener(type, listener, listenerOptions);

    this.listeners.push(stop);
  }
}

export default EventController;
